// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Kevin",
  middleName: "",
  lastName: "Tran",
  message: " Passionate about changing the world with technology. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/minhkhoiii1997",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/kevin-tran-912727163/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/kevin.jpeg"),
  imageSize: 400,
  message:
    "My name is Kevin Tran and I am graduated with B.S. in Computer Science. I have experience working on full-stack software development. I have built a few projects myself including mobile, web, and desktop applications. I have prior experience in doing an internship with T-Mobile in Summer 2020. While working there, I have exposed to some new technology such as data analysis using Python and displaying the information in infographic using a software called Power BI. As an adept Tutor for Computer Science, Mathematics as well as RF Engineer Intern, I have well-rounded skill set in C, C++, Java, C#, Python, SQL, JavaScript, HTML, CSS, Selenium, ASP.NET, and Xamarin. Furthermore, I am currently working as a Student – System Administrator role at University of Utah, which helps me in well-rounded skill set in security protocol and using PowerShell scripts.",
  resume: "https://docs.google.com/document/d/1cJf2vCMMqbBpCkvjPIMSwzYlXAoDe0mrlH9UUlGs1GI/edit?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "minhkhoiii1997", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["mentoru", "URC-Web-Application", "Selenium-scaper", "CalculatorApp", "Light-out", "Symphony"],
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Highlight",
  message:
    "Do you ever wonder if the classes you are taking will set you up for success in your desired career? MentorU is a cross platform mobile application to connect alumni and students from the University of Utah to facilitate a social and interactive mentoring platform for students seeking guidance. We hope this encourages students to make better career choices and stay motivated to finish their degrees by matching them with alumni in the industry that best interests them. ",
  images: [
    { 
      img: require("../editable-stuff/highlight-1.png"), 
      // label: "First slide label", 
      // paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/highlight-2.png"), 
      // label: "Second slide label", 
      // paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 70 },
    { name: "SQL", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 65 },
    { name: "JavaScript", value: 70 },
    { name: "HTML/CSS", value: 70 },
    { name: "C#", value: 90 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Engineering opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "minhkhoiii1997@gmail.com",
  phone: "(801) 970-3030"
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Student - Software Engineer',// Here Add Company Name
      companylogo: require('../assets/img/Ulogo_1200px.png'),
      date: 'August 2020 – December 2020',
    },
    {
      role: 'RF Engineer Intern',// Here Add Company Name
      companylogo: require('../assets/img/T-Mobile.png'),
      date: 'May 2020 – September 2020',
    },
    {
      role: 'System Administrator',
      companylogo: require('../assets/img/Ulogo_1200px.png'),
      date: 'January 2020 – May 2021',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
